import { ADD_PERMISSIONS, REMOVE_PERMISSIONS } from "./types"
import { PermissionLevel } from '../../types/auth'

export const addPermissions = (permissions: PermissionLevel[]) => ({ type: ADD_PERMISSIONS, permissions: permissions })

export const removePermissions = () => ({ type: REMOVE_PERMISSIONS })